import React from 'react';
import ErrorLogger from '../../services/ErrorLogger';

/**
 * ErrorBoundary Component
 * 
 * Componente que captura errores de React durante el renderizado
 * y los registra en el sistema de logging.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        // Actualizar estado para mostrar UI de fallback
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Registrar el error
        ErrorLogger.log(error, {
            componentStack: errorInfo.componentStack,
            type: 'React Component Error',
            operation: 'COMPONENT_RENDER'
        });

        this.setState({ errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary-fallback" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    textAlign: 'center',
                    backgroundColor: '#f8f9fa'
                }}>
                    <div style={{
                        maxWidth: '600px',
                        backgroundColor: 'white',
                        padding: '2rem',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                    }}>
                        <i className="bi bi-exclamation-triangle-fill text-danger"
                            style={{ fontSize: '4rem' }}></i>

                        <h2 className="mt-3 mb-2">Algo salió mal</h2>

                        <p className="text-muted mb-4">
                            Ha ocurrido un error inesperado. El problema ha sido registrado
                            automáticamente y será corregido en futuras actualizaciones.
                        </p>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="alert alert-danger text-start mb-3" style={{ fontSize: '0.875rem' }}>
                                <strong>Error:</strong> {this.state.error.toString()}
                            </div>
                        )}

                        <div className="d-flex gap-2 justify-content-center">
                            <button
                                className="btn btn-primary"
                                onClick={this.handleReload}
                            >
                                <i className="bi bi-arrow-clockwise me-2"></i>
                                Recargar página
                            </button>

                            <button
                                className="btn btn-outline-secondary"
                                onClick={this.handleGoHome}
                            >
                                <i className="bi bi-house me-2"></i>
                                Ir al inicio
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
